import Moment from 'moment';
import PdfGenerator from './PdfGenerator';

class GareElenco extends PdfGenerator {

    constructor(){
        super();
        this.doDrawCell = this.doDrawCell.bind(this);
    }

    doDrawCell(cell, data){
    }

    createPdf(items){

        const columns = [
            {title: "ID", dataKey: "id"},
            {title: "Codice", dataKey: "codice"},
            {title: "Nome", dataKey: "nome"},
            {title: "Cliente", dataKey: "cliente"},
            {title: "Note", dataKey: "note"},
            {title: "Data reg", dataKey: "dtreg"},
            {title: "Peso", dataKey: "peso"},
            {title: "Incasso\npresunto", dataKey: "incasso"},
            {title: "In commessa", dataKey: "incommessa"},
        ];
        let rows = [];
        items.map((item) => {
            let clienteDesc = (item.ragioneSociale ? item.ragioneSociale : '') + '\n' +
                (item.indirizzo ?  item.indirizzo : '' )+ ' ' +
                (item.cap ? item.cap : '') + ' ' +
                (item.citta ? item.citta : '') + ' ' +
                (item.provincia ? item.provincia : '') + ' ' +
                (item.stato ? item.stato : '') + '\n' +
                (item.piva ? 'p.iva:' + item.piva : '') + ' ' +
                (item.cfisc ? 'c.f.:' + item.cfisc : '');
            let it = {
                id: item.idGara,
                codice: item.codice,
                nome: item.nome,
                cliente: clienteDesc.trim(),
                note: (item.note ? item.note : ''),
                dtreg: (item.dataReg !== null ? Moment(item.dataReg).format('DD/MM/YYYY') : ''),
                peso: item.peso,
                incasso: this.formatCurrency(item.incassoPresunto),
                incommessa: item.idCommessa ? 'SI': 'NO',
            };
            rows.push(it);
            return 0;
        });

        super.createPdf(columns, rows,
            {
                createdCell: this.doDrawCell,
                styles: {
                    overflow: 'linebreak',
                    columnWidth: 'wrap',
                    fontSize: 7,
                },
                columnStyles: {
                    nome: {halign: 'left', columnWidth: '90'},
                    cliente: {halign: 'left', columnWidth: '120'},
                    note: {halign: 'left', columnWidth: '120'},
                    dtreg: {halign: 'center'},
                    peso: {halign: 'center'},
                    incommessa: {halign: 'center'},
                    incasso: {halign: 'right'},
                }
            });
    }


}

export default GareElenco;


/** WEBPACK FOOTER **
 ** ./src/pdf/GareElenco.js
 **/